// extracted by css-extract-rspack-plugin
export default {"Rating":"survey-response-field_Rating__E3xtH"};